import { Slider, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { useQuotationContext } from '../contexts/QuotationContext';
import { ProductVariable } from '../graphql';

const EnhancedSlider = withStyles(() => ({
  thumb: {
    width: 16,
    height: 16,
    marginTop: -6,
    border: '2px solid currentColor',
  },
  track: {
    height: 4,
    borderRadius: 4,
    color: '#dcdcdc',
  },
  mark: {
    width: 6,
    height: 6,
    marginTop: -3,
    color: '#dcdcdc',
    border: '2px solid currentColor',
    borderRadius: '50%',
  },
  markActive: { backgroundColor: 'currentColor' },
}))(Slider);

type Props = {
  productVariable: ProductVariable;
};

const OptionSlider = ({ productVariable }: Props) => {
  const max = productVariable.values.length - 1;

  const { selectedVariable, setSelectedVariable } = useQuotationContext();

  if (!selectedVariable) {
    return null;
  }

  return (
    <>
      <Typography gutterBottom>
        <FormattedMessage id={`${productVariable.attribute.key}.label`} />
      </Typography>
      <Typography gutterBottom>{selectedVariable.value}</Typography>
      <EnhancedSlider
        step={1}
        min={0}
        max={max}
        marks
        value={productVariable.values.indexOf(selectedVariable)}
        onChange={(_event, newValue) => {
          if (typeof newValue === 'number') {
            setSelectedVariable(productVariable.values[newValue]);
          }
        }}
      />
    </>
  );
};

export default OptionSlider;
